import {
    setCookie,
    initMenuTrigger,
    addHideScrolledMenuClass,
    addFancyboxFixForGallery,
    initGallerySlider,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews,
    faqService,
    initLazyBg,
    initShow
} from './functions';


import '../woocommerce/js/woocommerce';

// GLightbox NIE jest importowany statycznie — to ~55 KiB, a potrzebny tylko
// na stronach z obrazkami-linkami. Ładowany dynamicznie (osobny chunk
// glightbox.min.js), gdy na stronie są elementy pasujące do selektora.
const LIGHTBOX_SELECTOR = ".woocommerce-product-gallery__image a,.glightbox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], .wp-block-image.glightbox a";

const initLightbox = () => {
    if (!document.querySelector(LIGHTBOX_SELECTOR)) return;

    import(/* webpackChunkName: "glightbox" */ 'glightbox').then(({ default: GLightbox }) => {
        GLightbox({
            selector: LIGHTBOX_SELECTOR,
            slideEffect: 'fade',
            loop: true,
            dragAutoSnap: true,
        });
    });
};




//import gsap from "gsap";


const mainApp = () => {

    // init lazy loading backgrounds width .lazyBg
    initLazyBg();

    initShow('animUp');
    initShow('animDown');

    // init menu trigger
    initMenuTrigger();



    // add hideScrolledMenu class management based on scroll direction
    addHideScrolledMenuClass();



    //fix gallery id for slideshow ...
    addFancyboxFixForGallery('.wp-block-gallery');
    addFancyboxFixForGallery('.wp-block-image');

    //gallerySlider
    initGallerySlider();

    // add close function to cookies
    addCloseCookies();



    //start - contact form
    initForm();

    googleMapInit();


    initLoadNews();

    faqService();




}

document.addEventListener("DOMContentLoaded", mainApp, false);


(function ($) {
    const mainAppWithJquery = () => {


        $('.subpageHeader__goDown').click(function () {
            const scrollTarget = $(this).offset().top;
            $('html,body').animate({ 'scrollTop': scrollTarget + 'px' }, 500);
        });

        $(document).on('click', '#primary-menu .menu-item-has-children', function (e) {
            if (window.innerWidth < 1200) {
                e.stopPropagation();
                if (!$(this).hasClass('active')) {
                    $(this).addClass('active');
                    $(this).parent().addClass('activeParent');
                    $('.mainHeader__menuBack').addClass('show');

                    $('.mainHeader__menuHolder')[0].scrollTop = 0;
                } else {
                    $(this).removeClass('active');
                    $(this).parent().removeClass('activeParent');
                }
            }
        });

        $(document).on('click', '.mainHeader__menuBack', function () {
            $('.activeParent:last').removeClass('activeParent');
            $('#primary-menu .menu-item.active:last').removeClass('active');
            if ($('#primary-menu .menu-item.active:last').length > 0) {
                // $('.mainHeader__menuBack').html($('.menu-item.active:last').find('>a').html());
            } else {
                // $('.mainHeader__menuBack').html('');
                $('.mainHeader__menuBack').removeClass('show');
            }
        });
        $(document).on('click', '.menuTrigger', function () {
            $('.activeParent').removeClass('activeParent');
            $('#primary-menu .menu-item.active').removeClass('active');
            $('.mainHeader__menuBack').removeClass('show');

        });


        const viewportWidth = window.innerWidth;
        $('#primary-menu  a[href*="|"]').each(function (e) {

            let url = $(this).attr('href');
            let split_url = url.split('|');
            if (viewportWidth <= 782) {
                $(this).attr('href', split_url[0]);
            } else {
                $(this).attr('href', split_url[1]);
            }
        });

        $('a[href^="#"]').on('click', function (e) {
            e.preventDefault();
            var target = $(this).attr('href');
            if (target.length > 1) {
                var targetOffset = $(target).offset().top - 140;
                $('html, body').animate({
                    scrollTop: targetOffset
                }, 500);
            }
            return false;
        });


        if (window.location.hash) {
            window.setTimeout(() => {
                var target = window.location.hash;
                if ($(target).length > 0) {
                    var targetOffset = $(target).offset().top - 140;
                    $('html, body').animate({
                        scrollTop: targetOffset
                    }, 500);
                }
            }, 500);

        }

        $('.gAtuty__menuItem').on('click', function () {
            const target = $(this).data('target');
            $('.gAtuty__menuItem').removeClass('active');
            $(this).addClass('active');
            $('.gAtuty__contentItem').removeClass('active');
            $(`.gAtuty__contentItem#${target}`).addClass('active');

        });




        //rotator and sliders (slick ładowany warunkowo — guard na wypadek braku)
        if ($.fn.slick && $('.rotatorTop').length > 0) {
            $('.rotatorTop').slick({
                infinite: true,
                arrows: true,
                dots: true,
                autoplay: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                autoplaySpeed: 10000,
                fade: true,
                cssEase: 'linear'
            });

        }

        initLightbox();




    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);








